import { render, staticRenderFns } from "./PatientPrescriptionList.vue?vue&type=template&id=d1424fc6&"
import script from "./PatientPrescriptionList.vue?vue&type=script&lang=js&"
export * from "./PatientPrescriptionList.vue?vue&type=script&lang=js&"
import style0 from "./PatientPrescriptionList.vue?vue&type=style&index=0&id=d1424fc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports